module.exports = __webpack_public_path__ + "img/annotating-output.81ce9c37.svg";